import moment from "moment";
import app from '../main.js'


/**
 * Helper functions for date formatting and manipulation
 * @author LiveLaps Development Team
 * @version 1.0.0
 * @copyright LiveLaps Inc. 2024
 * @developer Leonardo Salas
 * @lastUpdate 2024-12-05
 * @lastUpdateAuthor Lorena Salas
 * @lastUpdateDescription Added locale-specific date formatting
 */

moment.createFromInputFallback = function(config) {
  config._d = new Date(config._i);
};
/**
 * Formats a given date for human-readable display.
 *
 * @param {Date} inputDate - The input date to be formatted.
 * @param {boolean} exportTime - Whether to include the time part in the formatted output. Default is true.
 * @param {boolean} exportSeconds - Whether to include seconds in the time part. Default is false.
 * @param {boolean} exportMilliseconds - Whether to include milliseconds in the time part. Default is false.
 * @returns {string} The formatted date according to the specified options.
 */
export function formatDateForHumans(inputDate, exportTime = true, exportSeconds = false, exportMilliseconds = false)
{
  if (!inputDate) return '';

  const locale = app.$i18n.locale;
  let dateFormat;

  switch (locale)
  {
    case 'es':
      dateFormat = 'MMMM D YYYY'      
      break;
    
    case 'fr':
      dateFormat = 'D MMMM YYYY'
      break;
  
    default:
      dateFormat = 'MMMM Do YYYY'
      break;
  }

  if(exportTime)
  {
    dateFormat = `${dateFormat} HH:mm`;
    
    if(exportSeconds)
    {
      dateFormat = `${dateFormat}:ss`;
    }
  }

  let response = moment(inputDate).locale(locale).format(dateFormat);

  if(exportSeconds && exportMilliseconds)
  {
    /**
     * Moment was rounding the milliseconds, beacuse that's not what we want, 
     * we will just take the millisecongs from the original inputdate 
     * and we will just place on the formatted response
     */
    const dateArray = inputDate.split('.');

    if(Array.isArray(dateArray) && dateArray.length === 2) {
      const milliseconds = dateArray[1];
      response = `${response}.${milliseconds}`;
    }
  }

  return response;
}
